/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentInstructors.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import InstructorList from '../../../components/InstructorList';
import UsageTracker from '../../../utils/UsageTracker';
import { mapShortProfessorToProfessor } from '../shortContentUtils.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentInstructors.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ShortContentInstructors = ({
  short
}) => {
  const {
    contentId: shortId,
    professors,
    language
  } = short;
  const mappedProfessors = professors.map(mapShortProfessorToProfessor(language));
  const trackProfessorClick = (professorId, organisation, organisationUrl) => () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'professor-organisation-click',
    contentType: 'SHORTFORM',
    appearsIn: 'short-form-content',
    organisation,
    organisationUrl,
    professorId,
    shortId
  });
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: trackProfessorClick,
      headingMarginBlockEnd: "200",
      headingPaddingBlockStart: "0",
      language: language,
      listPaddingInlineMobile: "0",
      professors: mappedProfessors
    })
  });
};